export default __webpack_public_path__ + "static/media/sample_image.97bc39ae.png";